module.exports = __webpack_public_path__ + "static/img/icon_help.f7070667.png";